module.exports = __webpack_public_path__ + "static/media/acg.e4fce178.jpg";